import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createUser } from "../api";
import "../styles/theme.css";

const RegistroPage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    id_usuario:"",
    usuario: "",
    contrasena: "",
    nombre_completo: "",
    file: "",
    curp: "",
    celular_personal: "",
    correo_electronico: "",
    acepto_responsiva: false,
    acepto_privacidad: false,
    acepto_reglamento: false,
  });

  const [image, setImage] = useState(null); // Estado para almacenar la imagen
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUser((prevUser) => ({
      ...prevUser,
      [name]: type === "checkbox" ? checked : value,
    }));

    const newErrors = { ...errors };

    // Validaciones
    if (name === "contrasena") {
      if (value.length < 8) {
        newErrors.contrasena = "La contraseña debe tener al menos 8 caracteres.";
      } else if (!/[A-Z]/.test(value)) {
        newErrors.contrasena = "Debe incluir al menos una letra mayúscula.";
      } else if (!/[0-9]/.test(value)) {
        newErrors.contrasena = "Debe incluir al menos un número.";
      } else {
        delete newErrors.contrasena;
      }
    }

    if (name === "celular_personal") {
      if (!/^\d{10}$/.test(value)) {
        newErrors.celular_personal = "El teléfono debe tener 10 dígitos.";
      } else {
        delete newErrors.celular_personal;
      }
    }

    if (name === "usuario") {
      if (!/^\w+$/.test(value)) {
        newErrors.usuario = "El usuario debe ser una sola palabra sin espacios ni caracteres especiales.";
      } else {
        delete newErrors.usuario;
      }
    }

    if (name === "curp") {
      const curp = String(value).trim().toUpperCase();
      const curpRegex = /^[A-Z]{4}\d{6}[A-Z]{5}[A-Z0-9]{3}$/;
      if (!curpRegex.test(curp)) {
        newErrors.curp = "El CURP no tiene un formato válido.";
      } else {
        delete newErrors.curp;
      }
    }

    setErrors(newErrors);
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!image) {
        alert("Por favor, adjunta un archivo antes de enviar.");
        return;
      }
  
      // Validar tamaño de la imagen (menor a 5 MB)
      const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB
      if (image.size > maxSizeInBytes) {
        alert("El tamaño de la imagen debe ser menor a 5 MB.");
        return;
      }
  
      const isVertical = await validateImageOrientation(image);
      if (!isVertical) {
        alert("Por favor, adjunta una imagen vertical (más alta que ancha).");
        return;
      }
  
      const formData = new FormData();
      formData.append("file", image);
      formData.append("usuario", user.usuario);
      formData.append("contrasena", user.contrasena);
      formData.append("nombre_completo", user.nombre_completo);
      formData.append("curp", user.curp);
      formData.append("celular_personal", user.celular_personal);
      formData.append("correo_electronico", user.correo_electronico);
      formData.append("acepto_responsiva", user.acepto_responsiva);
      formData.append("acepto_privacidad", user.acepto_privacidad);
      formData.append("acepto_reglamento", user.acepto_reglamento);
  
      await createUser(formData);
      alert("Usuario creado exitosamente.");
      navigate("/");
    } catch (error) {
      console.error("Error al crear usuario:", error);
      alert("Usuario duplicado, por favor intenta con otro.");
    }
  };
  
  const validateImageOrientation = (file) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            URL.revokeObjectURL(objectUrl); // Liberar la memoria usada por la URL del archivo
            resolve(img.height > img.width); // Verificar si la imagen es vertical
        };

        img.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            reject(new Error("No se pudo cargar la imagen."));
        };

        img.src = objectUrl; // Cargar el archivo como imagen
    });
  };

  const isFormInvalid = () => {
    const hasErrors = Object.values(errors).some((error) => error !== "");
    const requiredFieldsFilled =
      user.usuario !== "" &&
      user.contrasena !== "" &&
      user.nombre_completo !== "" &&
      user.curp !== "" &&
      user.celular_personal !== "" &&
      user.acepto_responsiva &&
      user.acepto_privacidad &&
      user.acepto_reglamento;
    return hasErrors || !requiredFieldsFilled;
  };

  return (
    <div className="container">
      <h1 className="title">Registro de Usuario</h1>
      <center><a href="/">home</a></center>
      <form onSubmit={handleSubmit} className="form" encType="multipart/form-data">
        <div className="input-group">
          <label className="label">Usuario:</label>
          {errors.usuario && <span className="error">{errors.usuario}</span>}
          <input type="text" name="usuario" value={user.usuario} onChange={handleChange} className="input" />
        </div>

        <div className="input-group">
          <label className="label">Contraseña:</label>
          {errors.contrasena && <span className="error">{errors.contrasena}</span>}
          <input type="password" name="contrasena" value={user.contrasena} onChange={handleChange} className="input" />
        </div>

        <div className="input-group">
          <label className="label">Nombre Completo:</label>
          <input type="text" name="nombre_completo" value={user.nombre_completo} onChange={handleChange} className="input" />
        </div>

        <div className="input-group">
          <label className="label">CURP:</label>
          (Asegúrate de que sea correcto. No se podrá cambiar en el futuro)
          {errors.curp && <span className="error">{errors.curp}</span>}
          <input type="text" name="curp" value={user.curp} onChange={handleChange} className="input" />
        </div>

        <div className="input-group">
          <label className="label">Celular:</label>
          {errors.celular_personal && <span className="error">{errors.celular_personal}</span>}
          <input type="text" name="celular_personal" value={user.celular_personal} onChange={handleChange} className="input" />
        </div>

        <div className="input-group">
          <label className="label">Correo Electrónico (opcional):</label>
          <input type="email" name="correo_electronico" value={user.correo_electronico} onChange={handleChange} className="input" />
        </div>

        <div className="input-group">
          <label className="label">Foto de Perfil:</label>
          <input type="file" name="file" onChange={handleImageChange} className="input" accept="image/*" />
        </div>
        <div className="checkbox-group">
          <input
            type="checkbox"
            name="acepto_responsiva"
            checked={user.acepto_responsiva}
            onChange={handleChange}
            className="checkbox"
          />
          <label>
          He leído y acepto la{" "}
            <a
              href="https://halcones.negociolocalmx.com/carta-responsiva"
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              Carta Responsiva
            </a>
          </label>
        </div>
        <div className="checkbox-group">
          <input
            type="checkbox"
            name="acepto_privacidad"
            checked={user.acepto_privacidad}
            onChange={handleChange}
            className="checkbox"
          />
          <label>
          He leído y acepto la{" "}
            <a
              href="https://halcones.negociolocalmx.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              Política de Privacidad
            </a>
          </label>
        </div>
        <div className="checkbox-group">
          <input
            type="checkbox"
            name="acepto_reglamento"
            checked={user.acepto_reglamento}
            onChange={handleChange}
            className="checkbox"
          />
          <label>
          He leído y acepto el{" "}
            <a
              href="https://halcones.negociolocalmx.com/reglamento"
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              Reglamento de Club Halcones
            </a>
          </label>
        </div>

        <button 
          type="submit" 
          className={`${isFormInvalid() ? 'button-disabled' : 'button'}`} 
          disabled={isFormInvalid()}
        >
          Registrar Usuario
        </button>
        <div className="terminos">
        <b>Para continuar recuerda</b><br></br>
        Todos los campos: Obligatorios (excepto correo electronico)<br></br>
        Imagen: Obligatoria, vertical y menor a 5MB<br></br>
        Terminos y condiciones deben ser aceptados
        </div>
      </form>
    </div>
  );
};

export default RegistroPage;
